import { createSelector } from '@reduxjs/toolkit';
import { selectDetails } from '../../store/selectors';

export const selectDocuments = createSelector(selectDetails, (details) => details.documents);

export const selectParameters = createSelector(selectDocuments, (documentsState) => documentsState.parameters);

export const selectEditDocument = createSelector(selectDocuments, (documentsState) => documentsState.documents.edit);
